export const ENTERPRISES_PERMISSIONS = {
  VIEW: 'get_enterprises',
  CREATE: 'create_enterprise',
  UPDATE: 'update_enterprise',
  DELETE: 'delete_enterprise',
} as const;

export type EnterprisesPermissions = typeof ENTERPRISES_PERMISSIONS[keyof typeof ENTERPRISES_PERMISSIONS];
